import { useEffect, type JSX } from 'react';
import { RemoveScroll } from 'react-remove-scroll';

// Small confirmation modal for destructive actions. Backdrop click or Esc cancels.
export function ConfirmDialog(props: {
  title: string;
  message?: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}): JSX.Element {
  const { title, message, confirmLabel = 'Confirm', onConfirm, onCancel } = props;

  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <RemoveScroll>
      <div className="confirm-overlay" onClick={onCancel}>
        <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
          <div className="modal-head">
            <h3>{title}</h3>
            <button className="modal-close" onClick={onCancel} title="Close">
              <i className="fas fa-times" />
            </button>
          </div>
          {message && <p className="muted">{message}</p>}
          <div className="confirm-actions">
            <button onClick={onCancel}>Cancel</button>
            <button className="danger" onClick={onConfirm}>
              <i className="fas fa-trash" /> {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </RemoveScroll>
  );
}
